import { render, staticRenderFns } from "./StreakButton.vue?vue&type=template&id=56e655b8&scoped=true&"
import script from "./StreakButton.vue?vue&type=script&lang=ts&"
export * from "./StreakButton.vue?vue&type=script&lang=ts&"
import style0 from "./StreakButton.vue?vue&type=style&index=0&id=56e655b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e655b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('56e655b8', component.options)
    } else {
      api.reload('56e655b8', component.options)
    }
    module.hot.accept("./StreakButton.vue?vue&type=template&id=56e655b8&scoped=true&", function () {
      api.rerender('56e655b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/StreakButton.vue"
export default component.exports